import { isDev } from '@workwave-tidal/core/base'
import { useCallback, useRef } from 'react'

export function useWarnOnce() {
  const rWarned = useRef(false)

  return useCallback((...messages: unknown[]) => {
    if (!rWarned.current && isDev()) {
      console.warn(...messages)
      rWarned.current = true
    }
  }, [])
}
